/**
     * click To Sort - Used when one of the table headings is clicked on.
     * sortByField passed is the name of the data column to sort on.
     * This function also controlls the up arrow, down arrow, or fa-sort arrows 
     * displayed in the table headings.  
     * @param {String} sortByField - column name for the data you want to sort on.
     * @param {String} lossClass - Current class of lossIcon (sort arrows).
     * @param {String} direction - Current sort direction (ascending or descending) will be toggled before sort.
     * @param {Array} data - The data to be sorted in the forn of an array.
     * @returns {Array}  Returns direction, lossClass, and sortByField.
  */
export function clickToSort(sortByField, lossClass, direction, data) {
    if(sortByField == "stateName"){
      //currentSort = "stateName"
      lossClass = "fas fa-sort"
      document.getElementById("beekeepersIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("BKExcIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("coloniesIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("colExcIcon").setAttribute("class", "fas fa-sort")

      let currentClass = document.getElementById("stateIcon")
      if(direction == "descending" || currentClass.className == "fas fa-sort"){
        document.getElementById("stateIcon").setAttribute("class", "fas fa-caret-square-up")
        direction = "ascending"
      }else{
        document.getElementById("stateIcon").setAttribute("class", "fas fa-caret-square-down")
        direction = "descending"
      } 
    }
  
    if(sortByField == "value"){  // Needs to be "value" to work in Highcharts defaults.
      //currentSort = "value"
      document.getElementById("stateIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("beekeepersIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("BKExcIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("coloniesIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("colExcIcon").setAttribute("class", "fas fa-sort")

      let currentClass = document.getElementById("lossIcon")
      if(direction == "descending" || currentClass.className == "fas fa-sort"){
        lossClass = "fas fa-caret-square-up"
        direction = "ascending"
      }else{
        lossClass = "fas fa-caret-square-down"
        direction = "descending"
      }  
    }
  
    if(sortByField == "Beekeepers"){
      //currentSort = "Beekeepers"
      document.getElementById("stateIcon").setAttribute("class", "fas fa-sort")
      lossClass = "fas fa-sort"
      document.getElementById("BKExcIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("coloniesIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("colExcIcon").setAttribute("class", "fas fa-sort")

      let currentClass = document.getElementById("beekeepersIcon")
      if(direction == "descending" || currentClass.className == "fas fa-sort"){
        document.getElementById("beekeepersIcon").setAttribute("class", "fas fa-caret-square-up")
        direction = "ascending"
      }else{
        document.getElementById("beekeepersIcon").setAttribute("class", "fas fa-caret-square-down")
        direction = "descending"
      }   
    }
  
    if(sortByField == "exclusiveBeekeepers"){
      //currentSort = "exclusiveBeekeepers"
      document.getElementById("stateIcon").setAttribute("class", "fas fa-sort")
      lossClass = "fas fa-sort"
      document.getElementById("beekeepersIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("coloniesIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("colExcIcon").setAttribute("class", "fas fa-sort")
      
      let currentClass = document.getElementById("BKExcIcon")
      if(direction == "descending" || currentClass.className == "fas fa-sort"){
        document.getElementById("BKExcIcon").setAttribute("class", "fas fa-caret-square-up")
        direction = "ascending"
      }else{
        document.getElementById("BKExcIcon").setAttribute("class", "fas fa-caret-square-down")
        direction = "descending"
      }   
    }
    
    if(sortByField == "Colonies"){
      //currentSort = "Colonies"
      document.getElementById("stateIcon").setAttribute("class", "fas fa-sort")
      lossClass = "fas fa-sort"
      document.getElementById("beekeepersIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("BKExcIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("colExcIcon").setAttribute("class", "fas fa-sort")
  
      let currentClass = document.getElementById("coloniesIcon")
      if(direction == "descending" || currentClass.className == "fas fa-sort"){
        document.getElementById("coloniesIcon").setAttribute("class", "fas fa-caret-square-up")
        direction = "ascending"
      }else{
        document.getElementById("coloniesIcon").setAttribute("class", "fas fa-caret-square-down")
        direction = "descending"
      }    
    }
  
    if(sortByField == "exclusiveColonies"){
      //currentSort = "exclusiveColonies"
      document.getElementById("stateIcon").setAttribute("class", "fas fa-sort")
      lossClass = "fas fa-sort"
      document.getElementById("beekeepersIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("BKExcIcon").setAttribute("class", "fas fa-sort")
      document.getElementById("coloniesIcon").setAttribute("class", "fas fa-sort")
  
      let currentClass = document.getElementById("colExcIcon")
      if(direction == "descending" || currentClass.className == "fas fa-sort"){
        document.getElementById("colExcIcon").setAttribute("class", "fas fa-caret-square-up")
        direction = "ascending"
      }else{
        document.getElementById("colExcIcon").setAttribute("class", "fas fa-caret-square-down")
        direction = "descending"
      }      
    }
  
    //return {
        //sortByField,
        //direction
    //}

    data.sort(dynamicSort(sortByField, direction))
    return {
        direction, 
        lossClass,
        sortByField
    }
}





/**
 * dynamic Sort - Used with .sort() method.  takes 2 parameters:
 * 'property' is the column name for the data you want to sort on.
 *  'direction' should be "ascending" or "desending" and determines what 
 *  direction the data is sorted.  Null values and 0's in the data will be sorted to 
 *  bottom of the sort regardless of the direction used.
 * @param  {String} property - column name for the data you want to sort on
 * @param  {String} direction - "ascending" or "descending".
 */
function dynamicSort(property, direction) {
    return function (a,b) {
      // Default direction is ascending (sortOrder = 1)
      var sortOrder = 1
      if(direction == "descending"){
        var sortOrder = -1
      }
      // This logic works with strings and numbers.
      if(isNaN(a[property])){  
        // Strings
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
        }else{  
          // Numeric
          var result = (a[property] - b[property])
          // Force null and 0 to bottom of sort.
          if (a[property] === null || a[property] == 0) {
            sortOrder = -1;
          }
          if (b[property] === null || b[property] == 0) {
            sortOrder = -1;
          }
        }
      
        return result * sortOrder;
    }
}



/**
 * Render One State Bar Chart - Displays a Higcharts bar chart for
 * a single state (one horizontal line).  Based on the parameters passed.
 * @param {String} oneStateName - name of the state the data goes with
 * @param {String} oneStatePerc - the value to base the bar chart on.  In this case the loss %.
 * @param {Array} oneStateCI - an array that contains the lower Confidence Interval and the upper Confidence Interval.
 * @param {String} divID - the ID of the HTML tag that will display the bar chart.
 */
export function renderOneStateBarChart(oneStateName, oneStatePerc, oneStateCI, divID)  {
  {
    Highcharts.chart( divID, {
      chart: {
          // rederto: divID,
          // backgroundColor:  '#FEF9E6',
          borderColor: '#000000',
          borderWidth: 1,
          type: 'bar',
          margin: [0, 3, 0, 3]
      },
      exporting: {
        enabled: false
      },
      title: {
          text: null
      },
      xAxis: {
          categories: oneStateName,
          gridLineWidth: 0 
      },
      yAxis: {
          min: 0,
          max: 100,
          gridLineWidth: 0
      },
      tooltip: {
        headerFormat: null,  // this line will suppress the name "Serries 1"
        outside: true.valueOf,
        formatter: function() {return  oneStateName + ': ' + ' ' + oneStatePerc + '% ' +  '<br> 95% Confidence Interval: ' + oneStateCI[0][0] +' - ' + oneStateCI[0][1]}
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: false
          }
        }
      },
      credits: {
          enabled: false
      },
      series: [
        {
          // dataLables in this case will print the state % inside the bar.
          dataLabels: {
            enabled: true,
            color: '#000',
            style: {fontWeight: 'bolder'},
            formatter: function() {return this.y + '%'},
            inside: true,
            align: 'left'
          },
  
          showInLegend: false, 
          name: null,
          //  Survey blue is #627d91.  Survey yellow is #dfab45. #e4831b looks good with hexagon map.
          color: '#dfab45',
          data: oneStatePerc
        }, 
        { 
          //  default: errorbar applies to the data it immediately follows
          type: 'errorbar',
          data: oneStateCI  
        }
      ]
  })
}

}
  